import { render, staticRenderFns } from "./HomeServicesSec.vue?vue&type=template&id=2e97fd5f&scoped=true&"
import script from "./HomeServicesSec.vue?vue&type=script&lang=js&"
export * from "./HomeServicesSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97fd5f",
  null
  
)

export default component.exports